import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            component: () => import('@/views/MainPage')
        },        
        {
            path: '/done',
            component: () => import('@/views/SubmissionComplete')
        },        
    ],
});

export default router;